import {
  BorderRadius,
  Colors,
  Spacing,
  Icon,
  InlineChildren,
  Media,
  Text,
} from '@doordash/design-language'
import { IconButton } from '@doordash/component-button'
import styled from 'styled-components'
import t from './strings'

export const FormContainer = styled.form`
  margin-top: ${Spacing.Medium}px;
`

type StripeFormProps = {
  hasError: boolean
}

export const InputContainer = styled.div`
  padding: ${Spacing.XxSmall}px;
  border: 1px solid
    ${(props: StripeFormProps) =>
      props.hasError ? Colors.TextError : Colors.BorderSecondary};
  border-radius: ${BorderRadius.Small}px;
`

export const SmallFormRow = styled(InlineChildren).attrs<{}>({
  alignItems: InlineChildren.Alignment.FlexEnd,
})`
  max-width: 240px;
`

export const NumberStyling = styled.div`
  flex: 2;
`

export const CVVStyling = styled.div`
  flex: 1;
`

export const BillingAddressStyling = styled.div`
  flex: 1;
  padding-right: ${Spacing.XxSmall}px;
`

export const ButtonStyle = styled.div`
  margin-right: ${Spacing.XSmall}px;
`

const ADD_CARD_ERROR_HEIGHT = '100'
export const AddCardErrorContainer = styled.div`
  height: ${ADD_CARD_ERROR_HEIGHT}px;
`

export const AddCardError = styled.div`
  padding: ${Spacing.Small}px;
  background-color: ${Colors.WarningBackground};
  border-radius: ${BorderRadius.Small}px;
  margin-bottom: ${Spacing.XxSmall}px;
  max-height: ${ADD_CARD_ERROR_HEIGHT}px;

  ${(props: StripeFormProps) =>
    props.hasError ? `visibility: visible` : `visibility: hidden`}
`

export const ButtonContainer = styled.div`
  display: flex;
  ${Media.Mobile`
      display: block;
      width: 90%;
      position: fixed;
      bottom: ${Spacing.Small}px;
      text-align: center;
      left: 0;
      right: 0;
      margin: 0 auto;
  `}
`

export const CvcIconButton = styled(IconButton).attrs<{}>({
  size: Icon.Sizes.Tiny,
  isInline: true,
  iconType: Icon.Types.InfoCircleLine,
  accessibilityLabel: t.cvcIcon__accessibilityLabel(),
})``

export const PaddedLabel = styled(Text).attrs<{}>({
  tag: 'label',
  styles: Text.Styles.Medium14,
})`
  padding-bottom: 6px !important;
`

export const CancelButtonContainer = styled.div`
  ${Media.Mobile`
    padding-top: ${Spacing.Medium}px;
  `}
`

export const DesktopButton = styled.div`
  display: block;
  ${Media.Mobile`
    display: none;
  `}
`

export const MobileButton = styled.div`
  display: none;
  ${Media.Mobile`
    display: block;
  `}
`
